// The 1.9.2 fork deleted the arrow / PageUp / PageDown cases from its
// keyboard handler "to prevent interference with stack control" (SmoothControls
// onKeyDown), so with the viewer focused those keys did nothing to the camera
// and reached the app's up/down hotkeys as they would anywhere else. Stock 4.x
// orbits and zooms on them (BZL-212).
//
// Stopping the keydown on its way to the viewer's own handler would also stop
// it reaching the app, so the key is taken off the viewer's path and handed on
// from the viewer's parent, as if the viewer had not had focus. A re-dispatched
// event is untrusted, which react-hotkeys-hook does not check; keyCode is
// copied because the library reads it.
const NAV_KEYS = new Set([
  'ArrowUp',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'PageUp',
  'PageDown',
]);
const KEY_CODES = {
  PageUp: 33,
  PageDown: 34,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
};

export function leaveNavKeysToApp(mv) {
  if (!mv || typeof window === 'undefined' || !window.customElements) return () => {};
  let root = null;
  let removed = false;

  const handler = (event) => {
    if (!NAV_KEYS.has(event.key) || event.__ogForwarded) return;
    // Before the viewer's handler (on an element inside this root) sees it.
    event.stopImmediatePropagation();
    const target = mv.parentNode;
    if (!target) return;
    const copy = new KeyboardEvent(event.type, {
      key: event.key,
      code: event.code,
      keyCode: KEY_CODES[event.key],
      which: KEY_CODES[event.key],
      repeat: event.repeat,
      shiftKey: event.shiftKey,
      ctrlKey: event.ctrlKey,
      altKey: event.altKey,
      metaKey: event.metaKey,
      bubbles: true,
      cancelable: true,
      composed: true,
    });
    copy.__ogForwarded = true;
    const notCancelled = target.dispatchEvent(copy);
    // Pass the app's preventDefault (e.g. a hotkey that scrolls a list) back.
    if (!notCancelled) event.preventDefault();
  };

  window.customElements.whenDefined('model-viewer').then(() => {
    if (removed) return;
    root = mv.shadowRoot;
    if (root) root.addEventListener('keydown', handler, true);
  });

  return () => {
    removed = true;
    if (root) root.removeEventListener('keydown', handler, true);
  };
}
